export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReENVW5pR0ItVVRGMTYtSEERIBSEVhEAn1oxAAMQ7zaDnW3vMQoLAe86DgAB7zMb7zIBAAHvDRsJAQAA7wSBBAxhBjAIB4RIAAGEUgIBhEYAAYRQg51wAYREEAGEQA==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/UniGB-UTF16-V.bcmap
// module id = 722
// module chunks = 3